import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetVersionPipe } from '../../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-library-header',
  standalone: true,
  imports: [AssetVersionPipe],
  templateUrl: './library-header.component.html',
  styleUrl: './library-header.component.scss',
})
export class LibraryHeaderComponent {
  @Input() hasContent: boolean = false;

  @Output() closePanel = new EventEmitter<void>();

  onClose(): void {
    this.closePanel.emit();
  }
}
